import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './ColorPicker.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "dropdown-container", staticClass: "color-picker" },
    [
      _c(
        "button",
        { attrs: { type: "button" }, on: { click: _vm.onTriggerClick } },
        [_c("div", { staticClass: "color", style: _vm.style })]
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            "is-open": _vm.open,
            offset: "0,8",
            "target-element": _vm.$refs["dropdown-container"],
            placement: "bottom-start"
          }
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.colors, function(color) {
              return _c("ColorCard", {
                key: color,
                attrs: { color: color, selected: _vm.selected },
                on: { "color-selected": _vm.onColorSelected }
              })
            }),
            1
          )
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-10c35af6";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ColorPicker/ColorPicker.vue.js